import { MissingDocumentActionTypes } from "models/actionTypes/missingDocumentActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const missingDocumentAccepted = (id: number): MissingDocumentActionTypes => {
  return {
    type: ReduxConstants.MissingDocumentActions.MISSING_DOCUMENT_ACCEPTED,
    payload: id,
  };
};

export const missingDocumentSnoozed = (id: number): MissingDocumentActionTypes => {
  return {
    type: ReduxConstants.MissingDocumentActions.MISSING_DOCUMENT_SNOOZED,
    payload: id,
  };
};

export const missingDocumentUpdated = (
  missingDocument: WintSuperkollAPIModel.MissingDocument
): MissingDocumentActionTypes => {
  return {
    type: ReduxConstants.MissingDocumentActions.MISSING_DOCUMENT_UPDATED,
    payload: missingDocument,
  };
};

export const missingDocumentUpdatedConent = (
  missingDocument: WintSuperkollAPIModel.MissingDocument
): MissingDocumentActionTypes => {
  return {
    type: ReduxConstants.MissingDocumentActions.MISSING_DOCUMENT_UPDATED_CONTENT,
    payload: missingDocument,
  };
};
